import { createContext, useContext, useState } from 'react';
import type { PropsWithChildren } from 'react';
import type { PromotionLayouts } from '@amplience/content-types/typings/s-plp-layout';

interface PromotionLayoutsContextProps {
  promotionLayouts?: PromotionLayouts;
}

export const PromotionLayoutsContext = createContext<PromotionLayoutsContextProps>({
  promotionLayouts: [],
});

export function PromotionLayoutsProvider({
  children,
  promotionLayouts,
}: PropsWithChildren<PromotionLayoutsContextProps>) {
  const [contextData] = useState<PromotionLayoutsContextProps>({
    promotionLayouts,
  });

  return <PromotionLayoutsContext.Provider value={contextData}>{children}</PromotionLayoutsContext.Provider>;
}

export function usePromotionLayoutsContext() {
  const { promotionLayouts } = useContext(PromotionLayoutsContext);

  return {
    promotionLayouts,
  };
}
